import React from 'react';
import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';
import { Link as BaseLink } from 'react-router5';
import { Route } from 'config/routes';
import BackArrow from 'assets/svg/right.svg';

const Link = styled(BaseLink)`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    text-decoration: none;
    color: ${theme.colors.neutrals.grey1};
    > svg {
      height: 24px;
      width: 24px;
      transform: ${theme.isRTL ? '' : 'rotate(180deg)'};
      fill: ${theme.colors.neutrals.grey1};
    }
    > div {
      margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(3)};
    }
  `}
`;

export const LinkToMadadLanding: React.FC<{ label?: string }> = props => {
  const { label } = props;
  return (
    <Link routeName={Route.MadadAgentPage}>
      <BackArrow />
      {label ? <SmallText>{label}</SmallText> : null}
    </Link>
  );
};
